import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Reason } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ReasonService extends BaseApiService<Reason> {
  get cacheKey(): StorageKey {
    return StorageKey.reasonServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/reasons`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return Reason.unparse(obj);
  }

  protected parse(obj) {
    return Reason.parse(obj);
  }
}
